import { render } from "./TermsOfService.vue?vue&type=template&id=63e33e3c"
const script = {}

import "./TermsOfService.vue?vue&type=style&index=0&id=63e33e3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__